import { useMutation, useQueryClient } from 'react-query';
import queries from '../queries';

const useDatasheetCreate = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ compressorId, filename, file }) => {
      return queries.datasheets.create.query({ compressorId, filename, file });
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.history.companiesHistory.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useDatasheetDelete = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id }) => {
      return queries.datasheets.delete.query(id);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.history.companiesHistory.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

export default {
  useDatasheetCreate,
  useDatasheetDelete,
};
